import FormattedMessage from 'I18n/components/FormattedMessage';
import Raven from 'raven-js';
import { jsx as _jsx } from "react/jsx-runtime";
const NO_PIPELINES_SELECTED = 0;
const ONE_PIPELINES_SELECTED = 1;
export const PipelineSelectButtonContent = ({
  isDealStageGrouping,
  pipelineFilterValues,
  pipelinesOptions
}) => {
  // Case: filtered to Forecast Categories & all pipelines selected (even if 'all' means 'one')
  // Note that the Deal Stage view can only have one pipeline selected at a time
  if (!isDealStageGrouping && pipelineFilterValues.length === pipelinesOptions.length) {
    return /*#__PURE__*/_jsx(FormattedMessage, {
      message: "repOverviewTable.filters.pipeline.all_text"
    });
  }

  // Case: no pipelines selected
  if (pipelineFilterValues.length === NO_PIPELINES_SELECTED) {
    return /*#__PURE__*/_jsx(FormattedMessage, {
      message: "repOverviewTable.filters.pipeline.placeholder"
    });
  }

  // Case: one pipeline selected
  if (pipelineFilterValues.length === ONE_PIPELINES_SELECTED && pipelinesOptions.length) {
    const selectedPipeline = pipelinesOptions.find(pipeline => pipeline.value === pipelineFilterValues[0]);
    if (selectedPipeline) {
      return /*#__PURE__*/_jsx("span", {
        children: selectedPipeline.text
      });
    }

    // Mismatch between pipelineFilterValues and pipelinesOptions
    Raven.captureMessage('Unable to find selectedPipeline in PipelineSelectButtonContent', {
      extra: {
        pipelinesOptions,
        pipelineFilterValues
      }
    });
  }
  return /*#__PURE__*/_jsx(FormattedMessage, {
    message: "repOverviewTable.filters.pipeline.countSelected",
    options: {
      count: pipelineFilterValues.length
    }
  });
};